import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import scrollOne from "../assets/images/scollOne.webp"
import scrollTwo from "../assets/images/scrollTwo.webp"
import scrollThree from "../assets/images/scrollThree.webp"
import scrollFour from "../assets/images/scrollFour.webp"
import scrollFive from "../assets/images/scrollFive.webp"
import scrollSix from "../assets/images/scrollSix.webp"
import productOne from "../assets/images/productOne.webp"
import productTwo from "../assets/images/productTwo.webp"
import productThree from "../assets/images/productThree.webp"

import "swiper/css";

const data = [
  {
    id: 1,
    title: "Strawberry Vanilla Sparkling Tonic",
    brand: "Olipop",
    rating: "100/100",
    desc: "Simple ingredients like strawberry juice with no harmful additives.",
    image: scrollOne,
  },
  {
    id: 2,
    title: "Organic Mango Juice",
    brand: "FreshCo",
    rating: "92/100",
    desc: "Naturally sweet mango pulp with zero preservatives.",
    image: scrollTwo,
  },
  {
    id: 3,
    title: "Berry Blast Soda",
    brand: "Zest",
    rating: "95/100",
    desc: "Low sugar sparkling drink with berry extracts.",
    image: scrollThree,
  },
  {
    id: 4,
    title: "Berry Blast Soda",
    brand: "Zest",
    rating: "95/100",
    desc: "Low sugar sparkling drink with berry extracts.",
    image: scrollFour,
  },
  {
    id: 5,
    title: "Berry Blast Soda",
    brand: "Zest",
    rating: "95/100",
    desc: "Low sugar sparkling drink with berry extracts.",
    image: scrollFive
  },
  {
    id: 6,
    title: "Berry Blast Soda",
    brand: "Zest",
    rating: "95/100",
    desc: "Low sugar sparkling drink with berry extracts.",
    image: scrollSix,
  },
  {
    id: 7,
    title: "Berry Blast Soda",
    brand: "Zest",
    rating: "95/100",
    desc: "Low sugar sparkling drink with berry extracts.",
    image: productOne,
  },
  {
    id: 8,
    title: "Berry Blast Soda",
    brand: "Zest",
    rating: "95/100",
    desc: "Low sugar sparkling drink with berry extracts.",
    image: productTwo,
  },
  {
    id: 9,
    title: "Berry Blast Soda",
    brand: "Zest",
    rating: "95/100",
    desc: "Low sugar sparkling drink with berry extracts.",
    image: productThree,
  },
];

export default function PremiumMobileShowcase() {
  const [activeIndex, setActiveIndex] = useState(0);

  const prevIndex =
    (activeIndex - 1 + data.length) % data.length;
  const nextIndex =
    (activeIndex + 1) % data.length;

  const activeItem = data[activeIndex];

  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-[rgba(208,229,230,0.04)] px-4">

      <div className="relative flex items-start justify-center">

        {/* 🔥 LEFT OUTSIDE IMAGE (closer + aligned) */}
        <motion.img
          key={prevIndex}
          transition={{ duration: 0.8 }}
          src={data[prevIndex].image}
          className="hidden md:block absolute left-[-90px] top-[120px] w-[90px] h-[90px] object-cover rounded-xl blur-md opacity-30"
        />

        {/* 🔥 RIGHT OUTSIDE IMAGE */}
        <motion.img
          key={nextIndex}
          src={data[nextIndex].image}
          className="hidden md:block absolute right-[-90px] top-[120px] w-[90px] h-[90px] object-cover rounded-xl blur-md opacity-30"
        />

        {/* 📱 PHONE */}
        <div className="relative w-[280px] sm:w-[320px] md:w-[360px] h-[580px] sm:h-[620px] md:h-[650px] rounded-[50px] border border-gray-300 bg-[#e5e5e5] p-[6px] shadow-xl">

          {/* NOTCH */}
          <div className="absolute top-3 left-1/2 -translate-x-1/2 w-[90px] sm:w-[110px] h-[22px] sm:h-[26px] bg-black rounded-full"></div>

          {/* SCREEN */}
          <div className="w-full h-full bg-white rounded-[42px] pt-16 flex flex-col">

            {/* 🔥 CAROUSEL AT TOP */}
            <div className="flex items-center h-[180px]">

              <Swiper
                modules={[Autoplay]}
                slidesPerView={3}
                centeredSlides={true}
                loop={true}
                spaceBetween={20}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                onSlideChange={(swiper) =>
                  setActiveIndex(swiper.realIndex)
                }
                className="w-full"
              >
                {data.map((item) => (
                  <SwiperSlide key={item.id}>
                    {({ isActive }) => (
                      <motion.div
                        animate={{
                          scale: isActive ? 1 : 0.75,
                          opacity: isActive ? 1 : 0.3,
                          filter: isActive
                            ? "blur(0px)"
                            : "blur(5px)",
                        }}
                        transition={{ duration: 0.4 }}
                        className="flex justify-center"
                      >
                        <img
                          src={item.image}
                          className="w-[90px] sm:w-[110px] h-[90px] sm:h-[110px] object-cover rounded-xl shadow-md"
                        />
                      </motion.div>
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>

            </div>

            {/* 🔥 DESCRIPTION IMMEDIATELY BELOW */}
            <div className="px-4 pt-2 pb-6">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeItem.id}
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 30, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="bg-white rounded-2xl p-4 shadow-md"
                >
                  <h2 className="text-sm sm:text-base font-semibold">
                    {activeItem.title}
                  </h2>

                  <p className="text-xs text-gray-500">
                    {activeItem.brand}
                  </p>

                  <div className="mt-2 flex items-center gap-2">
                    <span className="text-green-500 font-semibold text-sm">
                      {activeItem.rating}
                    </span>
                    <span className="text-xs text-gray-400">
                      Excellent
                    </span>
                  </div>

                  <p className="text-xs mt-2 text-gray-600">
                    {activeItem.desc}
                  </p>
                </motion.div>
              </AnimatePresence>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}